// src/axiosInstance.js
import axios from "axios";
import { server } from "./server";

const KEY = "auth_token";

export const setAuthToken = (t) => {
  try {
    if (t) sessionStorage.setItem(KEY, t);
    else sessionStorage.removeItem(KEY);
  } catch {
    // storage unavailable (private mode, etc.), fall back to cookie only
  }
};

const api = axios.create({ baseURL: server, withCredentials: true });

api.interceptors.request.use((config) => {
  let token = null;
  try {
    token = sessionStorage.getItem(KEY);
  } catch {}
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
